export default __webpack_public_path__ + "static/media/in500_3_11zon.0827641e.png";